import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep2_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F46.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame46() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);


        return (
            <div className="F46_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F46_entryBox">
                    <div className="F46_paragraph">
                        {language === 'english' ?
                            <p className="F46_paragraphEnglish">Teacher tells Saira that she should wait in the school bathroom, and she will get her a sanitary pad from the nearby shop right away. Saira asks the teacher wouldn’t it be wonderful if the school already had sanitary pads and a place where she could easily wash herself and change.</p>
                            :
                            <p className="F46_paragraphUrdu">ٹیچر سائرہ کو اس بات کی تاکید کرتی ہے کہ جب تک وہ قریبی دکان سے سائرہ کے لئے پیڈ خرید کر لاتی ہیں تب تک وہ باتھ روم میں ان کا انتظار کرے۔ سائرہ ٹیچر سے پوچھتی ہے کہ اچھانہ ہوتا اگر اسکول میں ہی پیڈ کے ساتھ ساتھ تبدیل کرنے اور اپنے آپ کو صاف کرنے کی جگہ بھی موجود ہو۔</p>
                        }
                    </div>

                    <div className="F46_timeline">
                        <div className='F46_timelineBar'>
                            <div className='F46_timelineFill'></div>
                            <span className='F46_timelineText'>17/19</span>
                        </div>
                    </div>

                    <div className="F46_nextFrames">
                        <div className="F46_nextFrame1"></div>
                        <div className="F46_nextFrame2"></div>
                        <div className="F46_nextFrame3"></div>
                    </div>

                    <div className='F46_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep2_lastVisitFrame(17)) }} className='F46_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
}

export default Frame46;